// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jitsi-meeting-loading-spinner {
  background: linear-gradient(to bottom, transparent var(--navbar-height-player-page-mobile), white var(--navbar-height-player-page-mobile)) !important;
}
@media (min-width: 1200px) {
  .jitsi-meeting-loading-spinner {
    background: linear-gradient(to bottom, transparent var(--navbar-height-player-page-desktop), white var(--navbar-height-player-page-desktop)) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/functional/JitsiMeeting/JitsiMeeting.scss"],"names":[],"mappings":"AAEA;EACI,qJAAA;AADJ;AAOI;EAPJ;IAQQ,uJAAA;EAJN;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
